import {
  SET_MODALVISIBLE,
  CLEANUP,
  SET_FUNDID,
  SET_MUTUALCREDIT_FUNDID,
  SET_VIRTUALACCOUNTNAME,
  SET_VIRTUALACCOUNTNUMBER,
  SET_ORIGINATOR,
  SET_ORIGINATORID,
  SET_SETTLEMENTCURRENCY,
  SET_SETTLEMENTAMOUNT,
  SET_SETTLEMENTAMOUNT_MINUS_FEE,
  SET_CLIENTFEEAMOUNT,
  SET_VALIDATESTATUS,
  GET_ORIGINATOR_REQUEST,
  GET_ORIGINATOR_SUCCESS,
  GET_ORIGINATOR_FAILURE,
  GET_BANKTRANSACTION_LINKS_REQUEST,
  GET_BANKTRANSACTION_LINKS_SUCCESS,
  GET_BANKTRANSACTION_LINKS_FAILURE,
} from "./addVaSettleType";

const initialState = {
  loading: false,
  modalVisible: false,
  fundId: null,
  bankTransactionLinks: [],
  mutualCreditFundId: null,
  virtualAccountNumber: null,
  virtualAccountName: null,
  originatorId: null,
  originator: null,
  settlementCurrency: null,
  settlementAmount: 0,
  settlementAmountMinusFee: 0,
  clientFeeAmount: 0,
  error: "",
  validateStatus: {
    industry: "success",
    industryErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.industry.errormsg",
    relationship: "success",
    relationshipErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.relationship.errormsg",
    purposeOfTransfer: "success",
    purposeOfTransferErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.purposeoftransfer.errormsg",
    sourceOfFund: "success",
    sourceOfFundErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.sourceoffund.errormsg",

    businessName: "success",
    businessNameErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.businessname.errormsg",
    incorporatedCountry: "success",
    incorporatedCountryErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.incorporatedcountry.errormsg",
    businessNumber: "success",
    businessNumberErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.businessnumber.errormsg",
    dateOfIncorporation: "success",
    dateOfIncorporationErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.dateofincorporation.errormsg",

    senderName: "success",
    senderNameErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.sendername.errormsg",
    countryOfResidence: "success",
    countryOfResidenceErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.countryofresidence.errormsg",
    idNumber: "success",
    idNumberErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.idnumber.errormsg",
    dateOfBirth: "success",
    dateOfBirthErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.dateofbirth.errormsg",

    originator: "success",
    originatorErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.originator.errormsg",
    clientFeeAmount: "success",
    clientFeeAmountErrorMsg:
      "app.modal.vasettlerxmodal.validatestatus.clientfeeamount.errormsg",
  },
};

const addVaSettleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEANUP: {
      return initialState;
    }

    case SET_MODALVISIBLE: {
      return {
        ...state,
        modalVisible: action.modalVisible,
      };
    }

    case SET_FUNDID: {
      return {
        ...state,
        fundId: action.fundId,
      };
    }

    case SET_MUTUALCREDIT_FUNDID: {
      return {
        ...state,
        mutualCreditFundId: action.mutualCreditFundId,
      };
    }

    case SET_VIRTUALACCOUNTNAME: {
      return {
        ...state,
        virtualAccountName: action.virtualAccountName,
      };
    }

    case SET_VIRTUALACCOUNTNUMBER: {
      return {
        ...state,
        virtualAccountNumber: action.virtualAccountNumber,
      };
    }

    case SET_ORIGINATOR: {
      return {
        ...state,
        originator: action.originator,
      };
    }

    case SET_ORIGINATORID: {
      return {
        ...state,
        originatorId: action.originatorId,
      };
    }

    case SET_SETTLEMENTCURRENCY: {
      return {
        ...state,
        settlementCurrency: action.settlementCurrency,
      };
    }

    case SET_SETTLEMENTAMOUNT: {
      return {
        ...state,
        settlementAmount: action.settlementAmount,
      };
    }

    case SET_SETTLEMENTAMOUNT_MINUS_FEE: {
      return {
        ...state,
        settlementAmountMinusFee: action.settlementAmountMinusFee,
      };
    }

    case SET_CLIENTFEEAMOUNT: {
      return {
        ...state,
        clientFeeAmount: action.clientFeeAmount,
      };
    }

    case SET_VALIDATESTATUS: {
      return {
        ...state,
        validateStatus: action.validateStatus,
      };
    }

    case GET_ORIGINATOR_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_ORIGINATOR_SUCCESS: {
      return {
        ...state,
        loading: false,
        originator: action.payload,
        error: "",
      };
    }

    case GET_ORIGINATOR_FAILURE: {
      return {
        ...state,
        loading: false,
        originator: null,
        error: action.payload,
      };
    }

    case GET_BANKTRANSACTION_LINKS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_BANKTRANSACTION_LINKS_SUCCESS: {
      return {
        ...state,
        loading: false,
        bankTransactionLinks: action.payload,
        error: "",
      };
    }

    case GET_BANKTRANSACTION_LINKS_FAILURE: {
      return {
        ...state,
        loading: false,
        bankTransactionLinks: [],
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export default addVaSettleReducer;
